import makeStyles from '@mui/styles/makeStyles';

const headerStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: '80%',
  },
  buttonStyle: {
    color: theme.palette.white,
    [theme.breakpoints.down(500)]: {
      width: '30px !important',
      height: '30px !important',
    },
  },
  input: {
    height: 5,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  shareButtons: {
    [theme.breakpoints.down('xl')]: {
      marginTop: '0px !important',
    },
    [theme.breakpoints.down(1280)]: {
      marginLeft: '60% !important',
      marginRight: '5% !important',
    },
    [theme.breakpoints.down(500)]: {
      marginLeft: '60% !important',
      marginRight: '5% !important',
    },
    [theme.breakpoints.down(400)]: {
      marginLeft: '60% !important',
      marginRight: '5% !important',
    },
    [theme.breakpoints.down(350)]: {
      marginLeft: '60% !important',
      marginRight: '15% !important',
    },
  },
  pdfButtons: {
    [theme.breakpoints.down('xl')]: {
      marginTop: '0px !important',
    },
    [theme.breakpoints.down(1280)]: {
      marginLeft: '-5% !important',
      marginRight: '5% !important',
    },
    [theme.breakpoints.down(550)]: {
      marginLeft: '-10% !important',
    },
    [theme.breakpoints.down(480)]: {
      marginLeft: '-15% !important',
    },
    [theme.breakpoints.down(427)]: {
      marginLeft: '-45% !important',
    },
    [theme.breakpoints.down(350)]: {
      marginLeft: '-59% !important',
    },
  },
  sildebarButtons: {
    marginLeft: '-100% !important',
    [theme.breakpoints.down(500)]: {
      width: '30px !important',
      height: '30px !important',
      marginTop: 10,
      marginLeft: '-79% !important',
    },
    [theme.breakpoints.down(400)]: {
      width: '30px !important',
      height: '30px !important',
      marginTop: 10,
      marginLeft: '-84% !important',
    },
    [theme.breakpoints.down(350)]: {
      width: '30px !important',
      height: '30px !important',
      marginTop: 10,
      marginLeft: '-89% !important',
    },
  },
  acceptQuote: {
    borderRadius: 25,
    backgroundColor: '#00315C',
    padding: theme.spacing(1.25, 2.5),
    fontSize: 'clamp(0.65rem, 0.75rem + 0.25vw, 0.875rem)',
    lineHeight: 1.35,
    textAlign: 'center',
    width: 'min(360px, 100%)',
    maxWidth: '100%',
    flexShrink: 1,
    minWidth: 0,
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#518CBF', color: '#ffffff' },
  },
  headerActionsBar: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2, 2, 3),
    overflow: 'visible',
  },
  headerActionsInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    width: '100%',
    minHeight: 48,
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      minHeight: 56,
      paddingRight: 112,
    },
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      paddingRight: 0,
    },
  },
  headerIconActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    [theme.breakpoints.up('lg')]: {
      position: 'absolute',
      right: theme.spacing(1),
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
  iconCircle: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#143f67',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    [theme.breakpoints.down(500)]: {
      width: 40,
      height: 40,
    },
  },
  nav: {
    width: '100%',
  },
  iconColor: {
    color: 'black',
  },
}));

export default headerStyles;
